module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "TheBond"
  }, [(_vm.items) ? _c('slider', {
    attrs: {
      "items": _vm.items,
      "restart": _vm.restartSlider
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c8a8094"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/TheBond.vue
// module id = 828
// module chunks = 1